/**
 * “科创中国”美团青山环保科技创新示范项目简介
 */
import React from 'react';
import './index.scss';
import Demonstration from '../../../components/Demonstration/Demonstration';
import Partner from '../../../components/Partner/Partner';
import { KechuangHeader } from '../../../components/KechuangHeader/KechuangHeader';

const Environment = () => {
  return (
    <div className="environment-intro">
      <KechuangHeader />
      <div className="about-project block-container marker" style={{ marginTop: 80 }}>
        <div id={'award'} style={{ position: 'relative', top: -150 }} />
        <span className="title" style={{ marginBottom: 40 }}>
          关于示范项目
        </span>
        <Demonstration />
        <div id="charter"></div>
      </div>

      <div className="block-container">
        <Partner />
      </div>
    </div>
  );
};

export default Environment;
